import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose, branch, renderNothing, renderComponent, withProps, setDisplayName } from 'react-recompose';
import includes from 'lodash/includes';
import { authorized } from '../containers/Authorization';
import GraphQLLoader from '../components/GraphQLLoader';
import GraphQLError from '../components/GraphQLError';
import { withEnabledFeatures } from './features';

export const HEAccountQuery = gql`
  query heAccountWithSubscriptions {
    viewer {
      id
      heAccount {
        id
        freemium
        activeSubscriptions
      }
    }
  }
`;

const withHEAccountSubscriptions = compose(
  authorized(),
  setDisplayName('withHEAccountSubscriptions'),
  graphql(HEAccountQuery),
  GraphQLLoader,
  GraphQLError,
  withProps(({ data: { viewer } }) => ({
    heAccount: viewer && viewer.heAccount,
  })),
);

function onHEAccountSubscription(predicate, options={}) {
  return compose(
    withHEAccountSubscriptions,
    setDisplayName('onHEAccountSubscription'),
    branch(
      ({ heAccount }) => !heAccount || !predicate(heAccount),
      renderComponent(options.failure || renderNothing()),
    ),
  );
}

function hasSubscription(subscription, options, active) {
  return compose(
    withHEAccountSubscriptions,
    setDisplayName(active ? 'onSubscriptionActive' : 'onSubscriptionInactive'),
    branch(
      ({ heAccount }) => !heAccount || [].concat(subscription).some((sub) => includes(heAccount.activeSubscriptions, sub)) !== active,
      renderComponent(options.failure || renderNothing()),
    ),
  );
}

// options.any: return true when any element in the list
function onAnySubscriptionActive(list, options = {}) {
  return compose(
    withEnabledFeatures,
    withHEAccountSubscriptions,
    setDisplayName('onAnySubcriptionActive'),
    branch(
      ({ heAccount }) => {
        /* istanbul ignore next */
        if (!heAccount) return true;
        return !list.some((sub) => includes(heAccount.activeSubscriptions, sub));
      },
      renderComponent(options.failure || renderNothing()),
    ),
  );
}

const onSubscriptionActive = (subscription, options={}) => hasSubscription(subscription, options, true);
const onSubscriptionInactive = (subscription, options={}) => hasSubscription(subscription, options, false);

export { onHEAccountSubscription, onSubscriptionActive, onSubscriptionInactive, withHEAccountSubscriptions, onAnySubscriptionActive };
